module.exports = __webpack_public_path__ + "img/index-1.8b898a76.png";